module.exports = __webpack_public_path__ + "img/9791191438017.78f6e0de.jpg";